import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaHospitalOpcoes.vue?vue&type=template&id=9ba642b4&scoped=true"
import script from "./ModalSolicitacaoCirurgiaHospitalOpcoes.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaHospitalOpcoes.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaHospitalOpcoes.vue?vue&type=style&index=0&id=9ba642b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba642b4",
  null
  
)

export default component.exports